import QueryString from 'qs';
import { ApiParams } from './types';
import { DEFAULT_HEADER_DATA, METHOD } from './constants';

const apiHandler = ({
  url,
  method,
  qsObject,
  headers,
  reqObj,
}: ApiParams): Promise<Response> => {
  const qs = QueryString.stringify(qsObject, { addQueryPrefix: true });
  const urlPath = `${url}${qs}`;

  return fetch(urlPath, {
    method,
    headers: {
      ...DEFAULT_HEADER_DATA,
      ...headers,
    },
    body: [METHOD.PUT, METHOD.POST, METHOD.PATCH, METHOD.DELETE].includes(
      method,
    )
      ? JSON.stringify(reqObj)
      : null,
  })
    .then((res) => Promise.resolve(res))
    .catch((err) => Promise.reject(err));
};

export default apiHandler;
